<template>
  <form-template @send-data="sendData" @delete-data="deleteData" :mode="mode">
    <v-text-field
      class="required"
      label="Firmen-Name"
      v-model.trim="nameInput"
      :rules="nameRules"
    ></v-text-field>
    <p><span style="color: red">*</span> notwendige Eingabe</p>
    <br />
  </form-template>
</template>

<script lang="ts">
import FormTemplate from "./FormTemplate.vue";
import { mapStores } from "pinia";
import { useOfficeStore } from "../../store/officeStore";

export default {
  data() {
    return {
      errorMessages: [] as string[],
      nameInput: "" as string | null,
      nameRules: [
        (val: string) => {
          if (!val) {
            return "Name notwendig.";
          }
          return val.length > 0 || "Name notwendig.";
        },
      ],
    };
  },
  components: { FormTemplate },
  props: {
    name: {
      type: String,
      validator: (val: string) => {
        return val.length > 0;
      },
      required: false,
    },
    mode: {
      type: String || null,
      required: true,
      validator(val: string) {
        return val === "post" || val === "put";
      },
    },
    currentId: {
      type: Number || null,
      required: false,
      default: null,
    },
    projectId: {
      type: Number || null,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapStores(useOfficeStore),
  },
  mounted() {
    // @ts-ignore
    if (this.mode === "put") {
      // @ts-ignore
      this.nameInput = this.name;
    }
  },
  emits: {
    "post-company": () => {
      return true;
    },
    "put-company": () => {
      return true;
    },
    "delete-company": () => {
      return true;
    },
  },
  methods: {
    async sendData() {
      let company: object;
      // @ts-ignore
      if (this.nameInput && this.projectId) {
        company = {
          name: this.nameInput,
        };
      } else {
        console.warn(
          "send-data-Event in company-form lead to no action. Data required for operation was not provided in props.",
        );
      }
      // @ts-ignore
      if (this.mode === "post") {
        try {
          // @ts-ignore
          await this.officeStore.postCompany(company, this.projectId);
          this.$emit("post-company");
        } catch (e) {
          console.warn(
            // @ts-ignore
            `Could not post Company, message from API: ${e.message}`,
          );
        }
        // @ts-ignore
      } else if (this.mode === "put") {
        try {
          // @ts-ignore
          company["project_id"] = this.projectId;
          // @ts-ignore
          await this.officeStore.putCompany(company, this.currentId);
          this.$emit("put-company");
        } catch (e) {
          console.warn(
            // @ts-ignore
            `Could not put Company, message from API: ${e.message}`,
          );
        }
      }
    },
    async deleteData() {
      // @ts-ignore
      if (this.currentId && this.projectId) {
        try {
          // @ts-ignore
          await this.officeStore.deleteCompany(this.currentId, this.projectId);
          this.$emit("delete-company");
        } catch (e) {
          console.warn(
            // @ts-ignore
            `Could not delete Company, message from API: ${e.message}`,
          );
        }
      } else {
        console.warn(
          "delete-data Event resulted in no action from company-form. Data required for operation was not provided in props.",
        );
      }
    },
  },
  watch: {
    mode(newVal) {
      if (newVal === "put") {
        // @ts-ignore
        this.nameInput = this.name;
      } else {
        this.nameInput = null;
      }
    },
  },
};
</script>
<style>
.required label::after {
  content: " *";
  color: red;
}
</style>
